import * as types from "../types";
import * as api from "../../http/api";
import that from "../../main";
import { Message } from "element-ui";
import { routerControl } from "../../router.js";
import Bus from '@/utils/eventBus.js';

const state = {
    userInfo: {},
    menuList: [],
    uploadUrl: "",
    isChange: false
};

const menuData = [
    {
        sys_code: "10",
        sys_namem: "首页",
        img: require("../../assets/image/sysMenu/sys1.png"),
        selectImg: require("../../assets/image/sysMenu/sys1-select.png")
    },
    {
        sys_code: "20",
        sys_namem: "数据监控",
        img: require("../../assets/image/sysMenu/sys5.png"),
        selectImg: require("../../assets/image/sysMenu/sys5-select.png")
    },
    {
        sys_code: "30",
        sys_namem: "能源管理",
        img: require("../../assets/image/sysMenu/sys3.png"),
        selectImg: require("../../assets/image/sysMenu/sys3-select.png")
    },
    {
        sys_code: "33",
        sys_namem: "微网",
        img: require("../../assets/image/sysMenu/ww.png"),
        selectImg: require("../../assets/image/sysMenu/ww-select.png")
    },
    {
        sys_code: "35",
        sys_namem: "储能监控",
        img: require("../../assets/image/sysMenu/cn.jpg"),
        selectImg: require("../../assets/image/sysMenu/cn-select.jpg")
    },
    {
        sys_code: "40",
        sys_namem: "充电桩监控",
        img: require("../../assets/image/sysMenu/cdz.png"),
        selectImg: require("../../assets/image/sysMenu/cdz-select.png")
    },
    {
        sys_code: "45",
        sys_namem: "空调监控",
        img: require("../../assets/image/sysMenu/kongtiao.png"),
        selectImg: require("../../assets/image/sysMenu/kongtiao-select.png")
    },
    {
        sys_code: "50",
        sys_namem: "光伏",
        img: require("../../assets/image/sysMenu/gf.jpg"),
        selectImg: require("../../assets/image/sysMenu/gf-select.jpg")
    },
    {
        sys_code: "56",
        sys_namem: "双碳",
        img: require("../../assets/image/sysMenu/st.png"),
        selectImg: require("../../assets/image/sysMenu/st-select.png")
    },
    {
        sys_code: "60",
        sys_namem: "系统配置",
        img: require("../../assets/image/sysMenu/sys9.png"),
        selectImg: require("../../assets/image/sysMenu/sys9-select.png")
    },
    {
        sys_code: "70",
        sys_namem: "电表安装",
        img: require("../../assets/image/sysMenu/sys6.png"),
        selectImg: require("../../assets/image/sysMenu/sys6-select.png")
    },

    {
        sys_code: "90",
        sys_namem: "消防管理",
        img: require("../../assets/image/sysMenu/sysxf.png"),
        selectImg: require("../../assets/image/sysMenu/sysxf-select.png")
    }
];

const mutations = {
    [types.LOG_GETUSERINFO](state, status) {
        menuData.forEach(element => {
            status.sys_codes.forEach(item => {
                if (element.sys_code == item.sys_code) {
                    item["img"] = element.img;
                    item["selectImg"] = element.selectImg;
                }
            });
        });
        state.userInfo = Object.assign({}, status);
    },
    [types.INDEX_GETMENULIST](state, status) {
        state.menuList = [...status];
    },
    [types.IS_CHANGE_SYSTEM](state, status) {
        state.isChange = status;
    }
};

const getters = {
    userInfo: state => state.userInfo,
    roles: state => state.userInfo.user_type,
    isOpenMenuList: state => {
        let arr = [];
        if (state.menuList.length) {
            state.menuList.forEach((element, index) => {
                if (index == 0) {
                    arr.push({
                        ...element,
                        isOpen: true
                    });
                } else {
                    arr.push({
                        ...element,
                        isOpen: false
                    });
                }
            });
        }
        return arr;
    }
};

const actions = {
    /**
     * 获取用户信息
     */

    getUserInfo({ commit, dispatch, rootState }, isRefresh) {
        api.getUserInfo().then(res => {
            if (res && res.error_code === "0") {
                sessionStorage.setItem(
                    "userInfo",
                    JSON.stringify(res.bus_json.user_id)
                );
                sessionStorage.setItem(
                    "btns",
                    JSON.stringify(res.bus_json.btnList)
                );
                commit(types.LOG_GETUSERINFO, res.bus_json);
                let activeSys = sessionStorage.getItem("activeSys");
                // 是否选择过系统
                // console.log("getUserInfo: ", activeSys);
                if (activeSys) {
                    dispatch("getMenuListByRoles", activeSys);
                } else {
                    // dispatch(
                    //     "getMenuListByRoles",
                    //     res.bus_json.sys_codes[0].sys_code
                    // );
                    if (
                        res.bus_json.sys_codes &&
                        res.bus_json.sys_codes.length
                    ) {
                        dispatch(
                            "getMenuListByRoles",
                            res.bus_json.sys_codes[0].sys_code
                        );
                    } else {
                        Message({
                            message: "没有可用的菜单！",
                            type: "warning"
                        });
                    }
                }
                dispatch("getCodeList");
            }
        });
    },
    getMenuInfo({ commit, dispatch, state }, url) {
        api.getMenuInfo({
            route_path: url
        }).then(res => {
            sessionStorage.setItem("activeSys", res.bus_json.sys_code);
            sessionStorage.removeItem("activeTab");
            sessionStorage.setItem("activeTab", url);
            sessionStorage.removeItem("header-title");
            sessionStorage.setItem("header-title", res.bus_json.menu_name);
            commit("IS_CHANGE_SYSTEM", false);
            dispatch("getMenuListByRoles", res.bus_json.sys_code);
        });
    },
    /**
     * 获取菜单列表
     */
    getMenuListByRoles({ commit, state }, sysId) {
        api.getMenuListByRoles({
            sys_code: sysId
        }).then(res => {
            if (res && res.error_code === "0") {
                let menuList = res.bus_json;

                routerControl(menuList);
                let activeTab = sessionStorage.getItem("activeTab");

                let path = "";
                let header_title = sessionStorage.getItem("header-title");
                if (menuList && menuList[0] && menuList[0].childlist) {
                    if (menuList[0].childlist[0].childlist) {
                        path = menuList[0].childlist[0].childlist[0].route_path;
                        if (!header_title)
                            header_title =
                                menuList[0].childlist[0].childlist[0].menu_name;
                                
                        Bus.$emit("currentMenuId", menuList[0].childlist[0].childlist[0].menu_id);
                    } else {
                        path = menuList[0].childlist[0].route_path;
                        if (!header_title)
                            header_title = menuList[0].childlist[0].menu_name;
                        Bus.$emit("currentMenuId", menuList[0].childlist[0].menu_id);
                    }
                } else {
                    path = menuList[0].route_path;
                    if (!header_title) header_title = menuList[0].menu_name;
                    Bus.$emit("currentMenuId", menuList[0].menu_id);
                }
                sessionStorage.setItem("header-title", header_title);
                commit(types.INDEX_GETMENULIST, res.bus_json);
                //  that.$router.push(path);

              //  console.log("为啥啊:", state.isChange, activeTab, path);

                // if (state.isChange) {
                //     that.$router.push(path);
                // } else {
                //     // 如果是刷新操作，那么存在激活的path，直接跳转
                //     if (activeTab && activeTab.length) {
                //         that.$router.push(activeTab);
                //     } else {
                //         // 第一次进入
                //         // 如果有首页，进入到首页

                //         // 如果没有首页，跳转到路由第一个页面
                //         that.$router.push(path);
                //     }
                // }
                if (
                    state.isChange &&
                    activeTab != "second-page" &&
                    activeTab != "10kv-switch-room" &&
                    activeTab != "assembly" &&
                    activeTab != "porcelain" &&
                    activeTab != "workshop" &&
                    activeTab != "battery-group"
                ) {
                    that.$router.push(path);
                } else {
                    if (activeTab && activeTab.length) {
                      //  that.$router.push(activeTab);
                      if (activeTab.startsWith('{')) {
                            const jsonTab = JSON.parse(activeTab);
                            that.$router.push({ name: jsonTab.name, query: jsonTab.query })
                        } else{
                            that.$router.push(activeTab);
                        }
                    } else {
                        that.$router.push(path);
                    }
                }
                return;
            }
        });
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};
